const DEFAULT_BASE_URL =
  process.env.REACT_APP_ODOO_URL || "https://bob-services-ship.odoo.com";

export class OdooAuthError extends Error {
  constructor(message, status, payload) {
    super(message);
    this.name = "OdooAuthError";
    this.status = status;
    this.payload = payload;
  }
}

export class OdooAuthClient {
  constructor(baseUrl = DEFAULT_BASE_URL) {
    this.baseUrl = baseUrl;
  }

  async postJson(path, body, apiKey) {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    if (apiKey) headers.Authorization = `Bearer ${apiKey}`;
    const response = await fetch(`${this.baseUrl.replace(/\/$/, "")}${path}`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });
    const payload = await response.json();
    if (!response.ok) {
      const message = typeof payload?.error === "string" ? payload.error : `HTTP ${response.status}`;
      throw new OdooAuthError(message, response.status, payload);
    }
    return payload;
  }

  async getJson(path, apiKey) {
    const response = await fetch(`${this.baseUrl.replace(/\/$/, "")}${path}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${apiKey}`,
      },
    });
    const payload = await response.json();
    if (!response.ok) {
      const message = typeof payload?.error === "string" ? payload.error : `HTTP ${response.status}`;
      throw new OdooAuthError(message, response.status, payload);
    }
    return payload;
  }

  login(request) {
    return this.postJson("/api/auth/login", {
      ...request,
      device_name: request.device_name || "BOB website",
    });
  }

  me(apiKey) {
    return this.getJson("/api/auth/me", apiKey);
  }
}

export const ODOO_API_KEY_STORAGE_KEY = "bob_odoo_api_key_v1";
export const ODOO_API_KEY_EXPIRES_KEY = "bob_odoo_api_key_expires_v1";

export async function loginToOdoo(credentials, storage, baseUrl) {
  const auth = new OdooAuthClient(baseUrl);
  const session = await auth.login(credentials);
  await storage.setItem(ODOO_API_KEY_STORAGE_KEY, session.api_key);
  await storage.setItem(ODOO_API_KEY_EXPIRES_KEY, session.expires_at);
  return session;
}

export async function clearOdooSession(storage) {
  await storage.removeItem(ODOO_API_KEY_STORAGE_KEY);
  await storage.removeItem(ODOO_API_KEY_EXPIRES_KEY);
}

export async function loadStoredOdooApiKey(storage) {
  const apiKey = await storage.getItem(ODOO_API_KEY_STORAGE_KEY);
  if (!apiKey) return null;
  const expiresAt = await storage.getItem(ODOO_API_KEY_EXPIRES_KEY);
  if (expiresAt && Number.isFinite(Date.parse(expiresAt)) && Date.parse(expiresAt) <= Date.now()) {
    await clearOdooSession(storage);
    return null;
  }
  return apiKey;
}
